export interface ICaseMovedModalProps {
  closeModal: () => void;
}

export const CASE_MOVED_MODAL_MESSAGE =
  "Case has been processed and moved out of your tray.";
